//
//  SDKAssetFormat.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var AssetFormat;
(function (AssetFormat) {
    AssetFormat["png"] = "png";
    AssetFormat["pdf"] = "pdf";
    AssetFormat["svg"] = "svg";
})(AssetFormat || (AssetFormat = {}));
